import { render, staticRenderFns } from "./CompanyEdit.vue?vue&type=template&id=61d9e882&scoped=true&"
import script from "./CompanyEdit.vue?vue&type=script&lang=ts&"
export * from "./CompanyEdit.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyEdit.vue?vue&type=style&index=0&id=61d9e882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d9e882",
  null
  
)

export default component.exports